import { checkValidity, fetchViewHistory } from "@src/common/service/viewHistory";
import {SimpleJobPanel} from "@react/pc/viewed/component/SimpleJobPanel"
import {useEffect, useState} from "react";
import {usePage} from "@inertiajs/react";

// 閲覧履歴の最大表示件数
const MAX_COUNT = 3;

export const ViewedJobsModal = (props) => {
    const { route } = usePage().props;

    const [viewHistory, setViewHistory] = useState(fetchViewHistory().splice(0, MAX_COUNT));

    useEffect(() => {
        checkValidity(fetchViewHistory()).then(() => {
            setViewHistory(fetchViewHistory().splice(0, MAX_COUNT));
        });
    }, []);

    // 1件以上ある時の表示
    const showViewHistory = () => {
        const jobPanels = viewHistory.map((viewedJob) => {
            return (
                <SimpleJobPanel
                    key={viewedJob.addTime}
                    viewedJob={viewedJob}
                    modalViewModel={props.modalViewModel}
                />
            );
        });

        return (
            <>
                <ul className="p-header_balloon_cont">
                    {jobPanels}
                </ul>
                <div className="u-ta_r">
                    <a href={route.web.viewed} className="c-text_link u-fs14" rel="nofollow">
                        {props.modalViewModel.translations.all_viewed_jobs}<img className="u-ml5" src="/webfront/images/icon/arrow_right_font-base.svg" width="14" height="6" alt="" />
                    </a>
                </div>
            </>
        );
    }

    // 0件表示
    const showNothing = () => {
        return (
            <p className="u-mt20 u-fs16">{props.modalViewModel.translations.you_have_no_viewed_jobs}</p>
        );
    }

    return (
        <>
            <div className="p-header_balloon-overlay s-header_balloon-overlay"></div>
            <div className="p-header_balloon p-header_balloon--viewedJobs">
                <p className="c-title c-title--3">{props.modalViewModel.translations.viewed_jobs}</p>
                {viewHistory.length === 0 ? showNothing() : showViewHistory()}
            </div>
        </>
    );
}
